export const NotificationMessages = {
  UPDATE_SHIPPING_ADDRESS_SUCCESS: 'Update Shipping Address Success!',
  UPDATE_SHIPPING_ADDRESS_FAILED: 'Update Shipping Address Failed!',
  UPDATE_CUSTOMER_DETAILS_TITLE: 'Update Details Form',
  UPDATE_CUSTOMER_DETAILS_SUCCESS: 'Update Personal Details Success!',
  UPDATE_CUSTOMER_DETAILS_FAILED: 'Update Personal Details Failed!',
  UPDATE_BILLING_ADDRESS_SUCCESS: 'Update Billing Address Success!',
  UPDATE_BILLING_ADDRESS_FAILED: 'Update Billing Address Failed!',
  UPDATE_PASSWORD_SUCCESS: 'Update Password Success!',
  UPDATE_PASSWORD_FAILED: 'Update Password Failed!',
  SETUP_PAYMENT_FAILED: 'Payment Setup Failed!',
  SETUP_PAYMENT_SUCCESS: 'Payment Setup Success!',
  CHECKOUT_PAYPAL_SUCCESS: 'Paypal Setup Success!',
  CHECKOUT_PAYPAL_ERROR: 'Paypal Setup Error!',
  ACCOUNT_PAYPAL_SUCCESS: 'Paypal Setup Success!',
  ACCOUNT_PAYPAL_ERROR: 'Paypal Setup Error!',
  EMAIL_SENT: 'Email successfully sent!',
  SUBSCRIPTION_CANCELLED: 'Your subscription was cancelled!',
};
